import React, { useState, useEffect } from 'react'
import SignupForm from './SignUpComponent'
import LoginForm from './LoginComponent'
import ReactDOM from 'react-dom';
import { AiOutlineClose } from 'react-icons/ai';


const LoginAndSignupModel = (props) => {
    useEffect(() => {
        if (props.userinfo)
            props.onClick(false)
    }, [props.userinfo])
    const [loginform, setloginform] = useState(true)
    return ReactDOM.createPortal(
        <>
            <div className='fixed top-0 left-0 bottom-0 right-0 bg-[rgba(0,0,0,0.75)]'>
                <div className='rounded-xl top-32 w-[23rem] h-[24rem] left-4 lg:w-[25rem] lg:h-[33rem] fixed lg:top-16 lg:left-[27rem]  bg-[#FFF]' >
                    <AiOutlineClose onClick={() => props.onClick(false)} className="h-8 w-8 absolute cursor-pointer p-2 rounded-lg  right-3 top-2 bg-[#CDE6FF] text-[#3399FF]" />
                    {loginform ? < LoginForm addUserDetailsToState={props.addUserDetailsToState}
                        onClick={(value) => setloginform(value)} />
                        : <SignupForm
                            onClick={(value) => setloginform(value)} />}

                </div>
            </div>

        </>, document.getElementById('portals')
    )
}

export default LoginAndSignupModel
